module.exports = __webpack_public_path__ + "img/icon-growth.513043c4.png";